import React, { ReactElement } from 'react';
import { Content } from './Content';

interface RegisterPhonePageProps {
  phone?: string;
}

function RegisterPhonePage({ phone }: RegisterPhonePageProps): ReactElement {
  return <Content phone={phone} />;
}

export { RegisterPhonePage };
